module.exports = __webpack_public_path__ + "static/media/og01.1e9e1786.webp";